jQuery(function( $ ) {
	$('section.hero-banner').each( function() {
		const $section = $(this);
		const $carousel = $( '.carousel', $section );
		const $bg_imgs = $( 'figure', $section );

		$carousel.slick({
			rows: 0,
			fade: true,
			arrows: true,
			dots: true,
			slidesToShow: 1,
			waitForAnimate: false,
			draggable: false,
			prevArrow: $( '.slick-arrows .prev', $section ),
			nextArrow: $( '.slick-arrows .next', $section ),
			appendDots: $section,
			customPaging: function( slider, i ) {
        return $('<button>').html($('<span>').addClass('sr-only').text( i + 1 ));
			},
			asNavFor: $bg_imgs,
		});

		$bg_imgs.slick({
			rows: 0,
			fade: true,
			arrows: false,
			dots: false,
			slidesToShow: 1,
			waitForAnimate: false,
			draggable: false,
		});

	});
});